import { MonoSynth } from "./MonoSynth.js";
import { BaixUI } from "../projectViews/stationViews/BaixUI.jsx";
import { addKeysAsField } from "../utils/misc.js";
import colors from "../../styles/colors.module.scss";

export class Baix extends MonoSynth {
    
    static metadata = {
        tipus: 'synth_bass',
        tipusDisplay: 'Synth Bass Legacy',
        versio: '0.1',
        color: colors.violet,
        hasLogo: true,
        hasMiniature: true,
    }
    static parametersDescription = addKeysAsField({
        ...super.parametersDescription,
        lpf_cutoff: {...super.parametersDescription.lpf_cutoff, initial: 500},
        osc_waveform: {...super.parametersDescription.osc_waveform, initial: 'square'},
        env_attack: {...super.parametersDescription.env_attack, initial: 0.01},
        env_decay: {...super.parametersDescription.env_decay, initial: 3.0},
        env_sustain: {...super.parametersDescription.env_sustain, initial: 0.0},
        env_release: {...super.parametersDescription.env_release, initial: 0.2},
        osc_detune: {...super.parametersDescription.osc_detune, initial: 1.01},
    }, "nom");
    static pitchRange = {
        ...super.pitchRange,
        usable: {min: 24, max: 47}
    }

    getUserInterfaceComponent() {
        return BaixUI;
    }
}